import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalSession } from "@/hooks/useLocalSession";
import { MiniNavbar } from "@/components/ui/mini-navbar";
import PromoCard from "@/components/PromoCard";

export const ResizableHeader = () => {
  const navigate = useNavigate();
  const isAuthenticated = useLocalSession();

  const navItems = [
    { label: "Features", href: "/features" },
    { label: "Pricing", href: "/pricing" },
    { label: "Contact", href: "/contact" },
  ];

  const logoElement = (
    <div className="flex items-center gap-2 cursor-pointer" onClick={() => startTransition(() => navigate('/'))}>
      <img
        src="/logo.png"
        alt="BankConvert Logo"
        width={39}
        height={32}
        fetchPriority="high"
        decoding="async"
        className="h-8 w-auto"
      />
    </div>
  );

  return (
    <>
      <MiniNavbar
        navItems={navItems}
        logoElement={logoElement}
        showAuthButtons={!isAuthenticated}
        onLoginClick={() => startTransition(() => navigate('/signin'))}
        onSignupClick={() => startTransition(() => navigate('/signup'))}
      />

      {isAuthenticated ? (
        <div className="fixed top-4 sm:top-6 right-3 sm:right-4 md:right-6 z-30">
          <button
            onClick={() => startTransition(() => navigate('/dashboard'))}
            className="px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm border border-[#1e0d01]/15 bg-white/90 backdrop-blur-md rounded-full transition-colors duration-200 shadow-lg whitespace-nowrap font-medium hover:border-primary/40"
            style={{ color: "rgba(30,13,1,0.7)" }}
          >
            Dashboard
          </button>
        </div>
      ) : (
        <div className="fixed top-4 sm:top-6 right-3 sm:right-4 md:right-6 z-30 hidden md:block">
          <PromoCard />
        </div>
      )}
    </>
  );
};

export default ResizableHeader;
